import request from '@/utils/request'

// 登录
export function login(data) {
    return request({
      url: '/api/account/login',
      method: 'post',
      data
    })
  }

// 获取文物分类的列表
export function getCategoryList(query) {
    return request({
        url: '/api/product/category/list',
        method: 'get',
        params: query
    })
}

// 获取文物的列表
export function getProductList(query) {
    return request({
        url: '/api/product/product/list',
        method: 'get',
        params: query
    })
}

// 获取文物详情
export function getProductDetail(id) {
    return request({
        url: `/api/product/product/detail/${id}`,
        method: 'get'
    })
}